import moment from 'moment';

export const formatTimeAgo = (utcDateString: string): string => {
  if (!utcDateString) return "";
  const date = moment.utc(utcDateString).local(); // Parse as UTC, convert to local
  if (!date.isValid()) return "";
  const now = moment();
  const diffInWeeks = now.diff(date, "weeks");
  if (diffInWeeks < 4) {
    return date.fromNow();
  } else {
    return date.format("MMM D, YYYY");
  }
};